import script from "./ClubPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubPublic.vue?vue&type=script&setup=true&lang=js"

import "./ClubPublic.vue?vue&type=style&index=0&id=01ffb516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ffb516"]])

export default __exports__